<div class="top-cont">
  <div class="business-services__container_pay">
    <div class="payment-services__inner-div_bus cus-bnd">
      <ul class="breadcrumb">
        <li class="breadcrumb-item active underlined-breadcrumb" aria-current="page">
          <a class="bread-hover-change" href="/business-services/">Business Services</a>
        </li>
        <li><a class="unselected-breadcrumb">Continuous Customs Bonds</a></li>
      </ul>
      <span>
        <h3 class="continuous-customs-bonds__inner-div--heading">Continuous Customs <br>Bonds</h3><br>
        <hr class="continuous-customs-bonds__hr">
      </span>
      <div class="continuous-customs-bonds__inner-div--content">
        One bond covers imports and speeds Customs <br>clearance for a year.
      </div>
      <div class="trade-button ">
        <a class="new-hero-button get-secret-btn" href="/business-services/continuous-customs-bonds/application/"
          tabindex="-1">Complete
          Application
          <img class="btn-mn0" src="../../../../assets/redesignImages/button-menu.png">
        </a>
      </div>
    </div>
    <img class="continuous-customs-bonds__image" alt="Business-services-img" src="../../../../assets/redesignImages/ContinuousCustomsBonds.png"
      width="590" height="330">
  </div>

  <img class="curved-image-media-value" src="../../../../assets/redesignImages/Vector.png">
</div>


<!-- Simplified International Shipping container -->


<h2 class="simplified-shipping__inner-container">
  Simplified International Shipping
</h2>
<hr class="simplified-shipping__hr-new">
<p class="simplified-shipping__inner-second-container">
  Use a continuous Customs bond to show proof of financial security for your imports.
</p>


<!-- UL container -->






<div class="row g-0 cont-bg1">
  <div class="col ic-grp ">
    <div class="text-center  img-tag">
      <img class="rounded mx-auto d-block ico-img" src="../../../../assets/redesignImages/ccb-img1.png" />
    </div>

    <div class="wrapper">

      <p class="tit-0 maj">Comprehensive <br> Coverage</p>
      <p class="tit-0 sml">A continuous Customs bond covers all your entries for the entire year.</p>
    </div>

  </div>
  <div class="col ic-grp">
    <div class="text-center img-tag">
      <img class="ico-img rounded mx-auto d-block" src="../../../../assets/redesignImages/ccb-img2.png" />
    </div>
    <div class="wrapper">
      <p class="tit-0 maj ">Customs <br>Compliance</p>
      <p class="tit-0 sml">Guarantees U.S. Customs and Border Protection receive payment for duties
        and fees.</p>
    </div>
  </div>
  <div class="col ic-grp ">
    <div class="text-center img-tag">
      <img class="ico-img rounded mx-auto d-block" src="../../../../assets/redesignImages/ccb-img3.png" />
    </div>
    <div class="wrapper">
      <p class="tit-0 maj">Time Saver</p>
      <p class="tit-0 sml">You can manage all your import entries with one bond.</p>
    </div>
  </div>
</div>

<!-- Limit Surprises at Customs container -->


<h2 class="para-limit-container simplified-shipping__inner-container1">
  Limit Surprises at Customs
</h2>
<hr class="simplified-shipping__hr">


<!-- Double-column Container -->

<div class="card-container">

  <div class="card fl0">


    <div class="card-img imgbn0">
      <img class="img-fluid" src="../../../../assets/redesignImages/LimitSurprisesatCustomsImg.png" />

    </div>
    <div class="card-body crB01">
      <div class="card-body-content">
        <ul class="ul-container-list">
          <li class="li-container-list">One place for surety bond management with import activity
            reporting.
          </li>
          <li class="li-container-list">Get updates on U.S. Customs and Border Protection trends and
            violations.
          </li>
          <li class="li-container-list">Help with Customs bond violations to file protests or petitions
            and
            relieve Customs claims.
          </li>
          <li class="li-container-list">Monitoring of bond sufficiency to support compliance with complex
            Customs regulations.</li>
          <li class="li-container-list">Experienced customer service team to handle bond renewal, accurate
            and
            timely bond filing and more.</li>
          <li class="li-container-list">Simplified underwriting process.</li>
          <div class="trade-button-ul-container">
            <a class="new-hero-button get-secret-btn container-button-margin" tabindex="-1"
              href="/business-services/continuous-customs-bonds/application/">Complete
              Application
              <img class="btn-mn0" src="../../../../assets/redesignImages/button-menu.png">
            </a>
          </div>


        </ul>

      </div>
    </div>
  </div>

</div>